(function () {
  function parseJSONScript(el) {
    try { return JSON.parse(el.textContent); } catch { return null; }
  }

  function toInt(v, fallback = 0) {
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  }

  function formatFiDate(iso) {
    // iso: "YYYY-MM-DD"
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || "");
    if (!m) return iso || "";
    return `${m[3]}.${m[2]}.${m[1]}`;
  }

  function isDateInFuture(dateString) {
    if (!dateString) return false;
    try {
      const date = new Date(dateString);
      const today = new Date();
      // Set both to midnight for fair comparison
      today.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);
      return date > today;
    } catch (e) {
      return false;
    }
  }

  function initOne(scope) {
    const variantsScript = scope.querySelector('script[data-restock-variants]');
    const infoEl = scope.querySelector('[data-restock-info]');
    if (!variantsScript || !infoEl) return;

    const payload = parseJSONScript(variantsScript);
    const variants = payload && Array.isArray(payload.variants) ? payload.variants : [];
    if (!variants.length) return;

    const form =
      scope.querySelector('form[action^="/cart/add"]') ||
      scope.closest('form[action^="/cart/add"]') ||
      scope.querySelector('product-form form[action^="/cart/add"]');

    if (!form) return;

    const qtyInput = form.querySelector('input[name="quantity"]');
    const idInput = form.querySelector('input[name="id"]');
    if (!qtyInput || !idInput) return;

    const dateEl = infoEl.querySelector('[data-restock-date]');
    const noteEl = infoEl.querySelector('[data-restock-note]');

    function getCurrentVariant() {
      const id = toInt(idInput.value, 0);
      return variants.find(v => Number(v.id) === Number(id)) || null;
    }

    function refresh() {
      const variant = getCurrentVariant();
      if (!variant) { infoEl.hidden = true; return; }

      const requested = Math.max(0, toInt(qtyInput.value, 0));
      const invQty = toInt(variant.inv_qty, 0);
      const policy = (variant.inv_policy || "").toLowerCase();
      const managed = !!variant.managed;
      const restockDate = variant.restock_date; // null | "YYYY-MM-DD"

      // Näytetään vain, jos varastoa hallinnoidaan, päivämäärä on olemassa JA tulevaisuudessa
      if (!managed || !restockDate || !isDateInFuture(restockDate)) {
        infoEl.hidden = true;
        return;
      }

      const shouldShowBecauseOutOfStock = invQty <= 0;
      const shouldShowBecauseOverRequestedWithOversell = (policy === "continue" && requested > invQty);

      if (shouldShowBecauseOutOfStock || shouldShowBecauseOverRequestedWithOversell) {
        if (dateEl) dateEl.textContent = formatFiDate(restockDate);
        if (noteEl) noteEl.hidden = policy !== "continue";
        infoEl.hidden = false;
      } else {
        infoEl.hidden = true;
      }
    }

    // Reaaliaikainen määrämuutos
    qtyInput.addEventListener('input', refresh);
    qtyInput.addEventListener('change', refresh);

    // Variantin vaihdot (Dawn vaihtaa idInput.value)
    form.addEventListener('change', () => {
      // pieni viive varmistaa, että idInput on ehtinyt päivittyä
      setTimeout(refresh, 0);
    });

    // Ensiajo
    refresh();
  }

  function initAll() {
    // Snippetti on yleensä product-info-alueella; haetaan kaikki esiintymät
    document.querySelectorAll('script[data-restock-variants]').forEach((script) => {
      const scope = script.parentElement || document;
      initOne(scope);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();
